import React from 'react'
import { SupplementalMedia } from 'Components/supplementalMedia'
import { TourGuide } from 'Components/tourGuide'
import { MainMedia } from 'Components/tourStop'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import { useSelector } from 'react-redux'
import { useGetLanguagesQuery, Labels } from 'Services/institution'

interface TourStopProps {
  stopData?: {
    stopid: number
    descriptionid: number
    description_id: number
    title: string
    stop_title: string
    main_media_id: number
    main_media_type: string
    media_id?: number
  }
  personalized?: boolean
  labels?: Labels
}

export const TourStopContainer = ({
  stopData: {
    stopid: stopId,
    descriptionid: descriptionId,
    description_id: personalizedDescriptionId,
    title,
    stop_title: personalizedTitle,
    main_media_id: mainMediaId,
    main_media_type: mainMediaType,
    media_id: pointMediaId,
  },
  personalized,
  labels,
}: TourStopProps) => {
  const { locId, instId } = useSelector((state: any) => state.location)
  const { data: allLangs } = useGetLanguagesQuery({
    instId,
    locId,
  })

  const label = labels && labels[stopId] && labels[stopId]?.join(', ') || null

  let ariaLabel = title || personalizedTitle
  if (label) {
    ariaLabel += `, the destination includes ${label}. `
  }
  if (personalized) {
    ariaLabel += ' For You'
  }

  return (
    <>
      <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          aria-label={ariaLabel}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div>
              <b style={{ paddingRight: '5px' }}>{title || personalizedTitle}</b>
              {label && <span style={{ fontSize: 14, color: '#6C7882' , marginLeft: '20px' }}>{label}</span>}
            </div>
            {personalized && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginRight: '18px' }}>
                <AutoAwesomeIcon
                  sx={{ color: 'gold', paddingRight: '5px', paddingLeft: '5px' }}
                />{' '}
                <span>For You</span>
              </div>
            )}
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <MainMedia id={mainMediaId} type={mainMediaType} pointMediaId={pointMediaId} stopId={stopId} stopTitle={title || personalizedTitle}/>
          {allLangs?.resources.map((lang) => (
            <TourGuide
              language={lang.language}
              descriptionId={descriptionId || personalizedDescriptionId}
            />
          ))}
          <Box component='div' sx={{ mb: 1 }}></Box>
          <SupplementalMedia stopId={stopId} mainMediaId={mainMediaId} />
        </AccordionDetails>
      </Accordion>
    </>
  )
}
